import { Drawer, Tag } from 'antd';
import type { UserData } from '../CampaignReport.type';
import { Icon } from 'Components';
import { INTERACTION_COLOR, RESULT_COLOR, STATUS_COLOR } from '../CampaignReport.constant';
import { formatDateTime, joinItems } from 'PhishingManager/utils';

const UserDetailDrawer = ({ data, visible, onClose }: {
  data: UserData | null,
  visible: boolean,
  onClose: () => void
}) => {
  const { color: resultColor, bg: resultBg } = RESULT_COLOR[data?.result || ''] || RESULT_COLOR.Failed;
  const { color: interactionColor, bg: interactionBg } = INTERACTION_COLOR;
  const name = `${data?.first_name || ""} ${data?.last_name || ""}`.trim();
  const confidenceTag = (data?.confidence || 'low')
  const confidenceColor = STATUS_COLOR[confidenceTag];
  const emailDeliveryTag = (data?.email_delivery || 'No');
  const emailDeliveryColor = STATUS_COLOR[emailDeliveryTag === "Yes" ? 'high' : 'low'];
  const ipAddress = `${data?.ip || ""} ${data?.city || ""}  ${data?.state || ""}  ${data?.country || ""}`.trim();
  const submissionDate = data?.event_date ? formatDateTime(data.event_date, "M/D/YYYY h:mm A") : '-';
  const sourceTag = data?.source === "system" ? "Automation Detected" : data?.source || '-';
  const sourceIcon = data?.source === "system" ? "systemInteraction" : "human";

  return (
    <Drawer
      title={
        <div className='header-section'>
          <div className='title-content'>
            <span className='title'>{name}</span>
            <Icon type='close' onClick={onClose} />
          </div>
          <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>{data?.result || ''}</Tag>
        </div>
      }
      className='user-data-drawer'
      placement="right"
      visible={visible}
      onClose={onClose}
      width={450}
      height="100vh">
      <div className='drawer-body'>
        <div className='data-section'>
          <span className='title'>Details</span>
          <span className='description'>Property: {joinItems(data?.properties || '', ", ")}</span>
          <span className='description'>Group: {joinItems(data?.groups || '', ", ")} </span>
          <span className='description'>Email Address: {data?.email || ''}</span>
        </div>

        <div className='data-section'>
          <span className='title'>Automation Analysis</span>
          <span className='description' style={{ textTransform: "capitalize" }}>{sourceTag} Interaction <Icon type={sourceIcon} style={{ background: "#E8F1FB" }} /></span> 
          <span className='description'>Confidence: <Tag className='status-tag' style={{ color: confidenceColor.color, background: confidenceColor.bg }} >{confidenceTag}</Tag></span>
          <span className='info-banner'>{data?.key_factors ?? '-'}</span>
        </div>

        <div className='data-section'>
          <span className='title'>Technical details</span>
          <span className='description'>{ipAddress}</span>
          <span className='description'>ISP: {data?.isp || '-'}</span>
          <span className='description'>User Agent:</span>
          <span className='info-banner'>{data?.user_agent || '-'}</span>
        </div>

        <div className='data-section'>
          <span className='title'>Delivery & Interaction</span>
          <span className='description'>Email delivered: <span style={{ textTransform: "capitalize" }}>{emailDeliveryTag}</span> <Icon type={emailDeliveryTag === "No" ? 'close' : 'check'} style={{ color: emailDeliveryColor.color, background: emailDeliveryColor.bg }} /></span>
          <span className='description'>Interaction: <Tag className='status-tag' style={{ color: interactionColor, background: interactionBg }}>{data?.interaction || '-'}</Tag></span>
          <span className='description'>Submission: {submissionDate}</span>
        </div>
      </div>
    </Drawer>
  );
};

export default UserDetailDrawer;